import type {Column} from "./Head";

function createActionColumnDef(): Column<string> {
	return {
		name: "",
		width: (theme) => `calc(1.5rem + ${theme.spacing(3.5)})`,
		padding: "checkbox",
	};
}

export default createActionColumnDef;
